import type { LucideIcon } from "lucide-react";
import { Award, FileCheck2, ShieldCheck, BadgeCheck } from "lucide-react";

export type TrustItem = {
  id: string;
  icon: LucideIcon;
  title: string;
  body: string;
};

/**
 * Homepage trust strip items. Remove any entry independently without layout breakage.
 * Values: see docs/trust-placeholders.md for sources and remaining unknowns.
 */
export const trustItems: TrustItem[] = [
  {
    id: "insured",
    icon: ShieldCheck,
    title: "Fully Insured",
    body: "$10 million commercial general liability. Certificate available on request.",
  },
  {
    id: "worksafebc",
    icon: FileCheck2,
    title: "WorkSafeBC Registered",
    body: "WorkSafeBC registered - clearance letter available on request.",
  },
  {
    id: "workmanship",
    icon: BadgeCheck,
    title: "Written Workmanship Warranty",
    body: "Issued in writing on every completed job under the agreed scope.",
  },
  {
    id: "manufacturer",
    icon: Award,
    title: "Manufacturer-Certified Installations",
    body: "Manufacturer-certified installations for the brands we install - eligible projects may qualify for enhanced material warranties.",
  },
];
